<!-- top content -->

<div class="main-card">
  <div class="card-content">
    <div class="left-col">
      <h1>
        <span class="highlight">11+ Creative Writing</span> | Rapid Course
      </h1>
      <p class="subtitle">
        Creative Writing Rapid Course for 11+ Exam Preparation—designed to cover key skills quickly and effectively in 6–8 weeks.
      </p>

      <div class="info-list">
        <div class="info-item">
          <i class="fa fa-diamond icon orange"></i>
          <span class="l-label"><strong>Category:</strong> 11+ RAPID COURSE</span>
        </div>
        <div class="info-item">
          <i class="fa fa-graduation-cap icon orange"></i>
          <span class="l-label"><strong>For:</strong> 11plus</span>
        </div>
        <div class="info-item">
          <i class="fa fa-book icon orange"></i>
          <span class="l-label"><strong>Boards:</strong> GL HBS, FSCE, SET, CSSE</span>
        </div>
        <div class="info-item">
          <i class="fa fa-users icon orange"></i>
          <span class="l-label"><strong>Year Applicable:</strong> Year 5</span>
        </div>
      </div>

      <div class="booking-card">
        <button (click)="bookSlot()" class="book-btn">Book a Slot</button>
        <div class="price">
          <span class="strike-price">£199.00</span>
          <span>  £149.00</span>
        </div>
      </div>
     
    </div>

    <div class="right-col">
      <img src="assets/images/cw-bg.jpg" alt="Course" />
    </div>
  </div>


  <!-- bottom info -->

 

  
</div>

<div class="bottom-info">
  <div class="bottom-card">
    <div class="bottom-item">
      <i class="fa fa-calendar icon orange"></i>
      <span class="bottom-label">Availability</span>
      <div class="bottom-value">
        <span>Available</span><br />
      </div>
    </div>
    <div class="bottom-item">
      <i class="fa fa-clock-o icon orange"></i>
      <span class="bottom-label">Duration</span>
      <div class="bottom-value strong">16 Hours</div>
    </div>
    <div class="bottom-item">
      <i class="fa fa-bullseye icon orange"></i>
      <span class="bottom-label">Target Age</span>
      <div class="bottom-value strong">10–11 Years</div>
    </div>
    <div class="bottom-item">
      <i class="fa fa-line-chart icon orange"></i>
      <span class="bottom-label">Level</span>
      <div class="bottom-value strong">Intermediate</div>
    </div>
  </div>
</div>


<!-- section 2 -->


<!-- Course Goal and Overview Section -->
<div class="section-goal-wrapper">
  <div class="goal-bar">
    <div class="goal-left">
      <span>Course Goal</span>
    </div>
    <div class="goal-right">
      <strong>Boost confidence, structure, and imagination<br>
        for the 11+ creative writing section
      </strong>
    </div>
  </div>
  
  <!-- About Course -->
  <div class="about-course">
    <h2>About Course</h2>
    <p class="desc-bold">
      <strong>Creative Writing Rapid Course for 11+ Exam Preparation</strong>—designed to cover key skills quickly and effectively in 6–8 weeks.
    </p>
    <p class="desc">
      A comprehensive 8 sessions (16 Hours) plan to cover the majority of 11plus entrance exams in UK - CSSE (Essex Grammar Schools), Henrietta Barnett School (HBS), St Olave's 2nd round, Sutton 2nd round, Private schools entry exams for year 7. These sessions are connected including Practical, Feedback & Frequently Asked Questions (FAQ) so we strongly recommend to attend all for better understanding & impact.
    </p>
  </div>
  
  <!-- Sessions Overview Row -->

  

  <div class="sessions-overview-row">

    <div class="session-features">
      <ul>
        <li><strong>8 Sessions / 2 Hours each</strong></li>
        <li>Creative writing basics and types</li>
        <li>Methods & techniques</li>
        <li>Structure & Styles</li>
        <li>Tips & Tricks</li>
        <li>Course Material / Notes will be provided</li>
        <li><strong>16 Practical / Exercises / Tests - Instant marking &amp; feedback.</strong></li>
        <li>Recorded Classes for parents &amp; students review*</li>
      </ul>
    </div>

    <div class="session-side-box">
      <span>Sessions Overview</span>
    </div>
  </div>

  
</div>


<!-- weekly breakdown -->

<div class="section-breakdown">
  <h2>Week-by-Week Breakdown</h2>

  <div class="accordion">
    <div
      class="accordion-item"
      *ngFor="let week of weeks; let i = index"
      [class.open]="openIndex === i"
    >
      <div class="accordion-header" (click)="toggleAccordion(i)">
        <span [innerHTML]="week.title"></span>
        <svg class="accordion-icon" width="32" height="32">
          <polyline points="10,14 16,20 22,14" fill="none" stroke="#222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div
        class="accordion-content"
        [style.maxHeight]="openIndex === i ? '900px' : null"
        [style.opacity]="openIndex === i ? '1' : null"
        [@accordion]="openIndex === i ? 'open' : 'closed'"
      >
        <div [innerHTML]="week.content"></div>
      </div>
    </div>
  </div>
</div>


<!-- course guide lines -->

<div class="guidelines-card">
  <h2>Class Guidelines</h2>
  <ul>
    <li>
      <strong>Student-Only Session:</strong> These live classes are exclusively for students. Parents are kindly requested not to attend.
    </li>
    <li>
      <strong>Joining Instructions:</strong> The meeting &amp; Home-work instructions will be sent via email upon registration. Students should join the class 5 minutes before the scheduled start time and are expected to follow the teacher’s instructions throughout.
    </li>
    <li>
      <strong>Submission Support:</strong> Students may need assistance from a parent or guardian to scan and upload their written work as a PDF for the teacher’s review and feedback.
    </li>
    <li>
      <strong>Home-work:</strong> Timely submission of Home-work is important for review and feedback
    </li>
  </ul>
  <div class="button-row">
    <button (click)="openExternalLink()" class="action-btn">Learn More</button>
  </div>
</div>

<!-- contact us section -->

<div class="contact-card">
  <div class="contact-icon-row">
    <i class="fa fa-envelope contact-icon"></i>
  </div>
  <h2>Contact Us for More Information</h2>
  <p class="contact-desc">
    Have a question or need further details? <br>
    We’re happy to help you with course schedules, registration, or any other query.
  </p>
  <ul class="contact-list">
    <li>
      <i class="fa fa-envelope"></i>
      <a href="mailto:info@example.com">Email: support&#64;sehyog.co.uk</a>
    </li>
    <li>
      <i class="fa fa-phone"></i>
      <a href="tel:+441234567890">Hotline: +44 (0)20 3980 8244</a>
    </li>
     <li>
      <i class="fa fa-whatsapp wa"></i>
      <a href="https://wa.me/447464772331">WhatsApp: +44 7464772331</a>
    </li>

    <li></li>
    <li></li>

  
    <li>*Terms & Conditions Apply</li>
  </ul>

</div>